import fetch from "unfetch"

export default fetch
